import React, { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import { Coupon } from '@carbon/pictograms-react';

import { FormattedMessageWrappedInSpan } from '../../misc';
import { DisabledToActiveButton } from '../../misc/Buttons';
import { PRESALE_EVENT_ON_WITH_ACTION } from '../../../utils/variables';
import SubsectionInFrame from '../../misc/SubsectionInFrame';

const PresaleEventInfo = (props) => {
  const { onShowRegularSearch, eventPresaleInfo } = props;
  const [showAdditionalSupportText, setShowAdditionalSupportText] = useState(false);

  return (
    <SubsectionInFrame
      actionable
      title={
        <FormattedMessageWrappedInSpan
          id="presaleEventInfo.didYouBuyQuestion.title"
          defaultMessage="Presale event"
          className="typography uppercase typography-title_small"
        />
      }
      lastInRow
      topPadding
      center
      gap={20}
    >
      <Coupon className="pictogram-100" />
      {!showAdditionalSupportText && (
        <FormattedMessageWrappedInSpan
          id="presaleEventInfo.didYouBuyQuestion.question"
          defaultMessage="Did you buy your photos when you signed up for the event?"
        />
      )}
      {showAdditionalSupportText && (
        <div
          data-testid="presale-message"
          dangerouslySetInnerHTML={{
            __html: eventPresaleInfo.presaleMessage,
          }}
        />
      )}
      {!showAdditionalSupportText && (
        <div className="subsection-action-double-buttons">
          <button
            className="warning-btn full-width subsection-action-button"
            onClick={onShowRegularSearch}
          >
            <FormattedMessageWrappedInSpan
              id="presaleEventInfo.didYouBuyQuestion.answerNo"
              defaultMessage="No"
              className="typography bold-text typography-title_xsmall"
            />
          </button>
          <button
            className="primary-new full-width subsection-action-button"
            onClick={() => setShowAdditionalSupportText(true)}
          >
            <FormattedMessageWrappedInSpan
              id="presaleEventInfo.didYouBuyQuestion.answerYes"
              defaultMessage="Yes"
              className="typography bold-text typography-title_xsmall"
            />
          </button>
        </div>
      )}
      {showAdditionalSupportText && (
        <DisabledToActiveButton
          className="primary-new subsection-action-button "
          onClick={onShowRegularSearch}
        >
          {eventPresaleInfo.presale === PRESALE_EVENT_ON_WITH_ACTION ? (
            <FormattedMessageWrappedInSpan
              id="presaleEventInfo.buttons.continue"
              defaultMessage="Continue"
              className="typography bold-text typography-title_xsmall"
            />
          ) : (
            <FormattedMessageWrappedInSpan
              id="presaleEventInfo.buttons.continueAnyway"
              defaultMessage="Continue anyway"
              className="typography bold-text typography-title_xsmall"
            />
          )}
        </DisabledToActiveButton>
      )}
    </SubsectionInFrame>
  );
};

PresaleEventInfo.propTypes = {
  onShowRegularSearch: PropTypes.func,
  eventPresaleInfo: PropTypes.object,
};

export { PresaleEventInfo };

export default createFragmentContainer(PresaleEventInfo, {
  eventPresaleInfo: graphql`
    fragment PresaleEventInfo_eventPresaleInfo on Event {
      presaleMessage
      presale
    }
  `,
});
